import { createContext } from 'react';
import { CreateApprovalContextValue } from '../../types';

export const CreateApprovalContext = createContext<CreateApprovalContextValue | null>(null);
